import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

const MAP = {
  primary: "--primary", secondary: "--secondary", accent: "--accent",
  background: "--background", surface: "--surface", foreground: "--foreground",
  muted_foreground: "--muted-foreground", border: "--border", radius: "--radius",
  font_heading: "--font-heading", font_body: "--font-body",
  h1_size: "--h1-size", h2_size: "--h2-size", h3_size: "--h3-size",
  sidebar_bg: "--sidebar-bg", sidebar_text: "--sidebar-text",
  dark_section_bg: "--dark-section-bg", dark_section_text: "--dark-section-text", dark_section_muted: "--dark-section-muted",
  footer_bg: "--footer-bg", footer_text: "--footer-text", footer_muted: "--footer-muted",
};

export function applyTheme(theme) {
  if (!theme) return;
  const root = document.documentElement;
  Object.entries(MAP).forEach(([k, cssVar]) => {
    if (theme[k] != null && theme[k] !== "") {
      root.style.setProperty(cssVar, theme[k]);
      if (k === "surface") root.style.setProperty("--card", theme[k]);
    }
  });
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/theme");
      setTheme(data);
      applyTheme(data);
    } catch {}
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, applyTheme, reload: load }}>
      {children}
    </ThemeContext.Provider>
  );
}
